import {
  FaintFill,
  Illustration,
  Outline,
  PageFill,
  StrongFill,
} from "./illustration";

interface Props {
  className?: string;
}

const TOP =
  "M13 8H69A7 7 0 0 1 76 15V31A7 7 0 0 1 69 38H13A7 7 0 0 1 6 31V15A7 7 0 0 1 13 8Z";
const BOTTOM =
  "M13 44H69A7 7 0 0 1 76 51V67A7 7 0 0 1 69 74H13A7 7 0 0 1 6 67V51A7 7 0 0 1 13 44Z";
const ALERT = "M56 74A18 18 0 1 1 92 74A18 18 0 1 1 56 74Z";

// Two server units with an alert on them.
export function ServerDownIllustration({ className }: Props) {
  return (
    <Illustration width={96} height={96} className={className}>
      <PageFill d={TOP + BOTTOM} />
      <FaintFill d={TOP} />
      <StrongFill d={BOTTOM} />
      <Outline d={`${TOP}${BOTTOM}M41 38V44M46 23H66M46 59H52`} />
      <path d="M15.8 23A2.2 2.2 0 1 1 20.2 23A2.2 2.2 0 1 1 15.8 23ZM23.8 23A2.2 2.2 0 1 1 28.2 23A2.2 2.2 0 1 1 23.8 23ZM15.8 59A2.2 2.2 0 1 1 20.2 59A2.2 2.2 0 1 1 15.8 59ZM23.8 59A2.2 2.2 0 1 1 28.2 59A2.2 2.2 0 1 1 23.8 59Z" />
      <PageFill d={ALERT} />
      <StrongFill d={ALERT} />
      <Outline d={`${ALERT}M74 64V76`} />
      <path d="M72 83A2 2 0 1 1 76 83A2 2 0 1 1 72 83Z" />
    </Illustration>
  );
}
